import { initialize } from 'react-ga';

const trackingId =
  window && (window.PT_ENV === 'staging' || window.PT_ENV === 'prod')
    ? 'UA-157135427-1'
    : 'UA-157135427-2';

initialize(trackingId);
